import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ChannelList from "./ChannelList";
import ChatWindow from "../chat/ChatWindow";
// keep your current import; if it's really a default export, use Option A above
import { ChatSocketProvider } from "../chat/ChatSocketProvider";
import { getUserInfoFromToken } from "../../utils/Main";
import { Typography, Box } from "@mui/material";

// ---- Add this: declare the expected prop shape and alias the component ----
type AuthUser = { id: number; token?: string };
type ProviderProps = { authUser: AuthUser; children?: React.ReactNode };

// Coerce/alias ChatSocketProvider to a component that accepts `authUser`
const Provider = ChatSocketProvider as unknown as React.ComponentType<ProviderProps>;
// ---------------------------------------------------------------------------

export default function ChatPage() {
  const auth = useMemo(() => getUserInfoFromToken(), []);
  const userId: number | undefined = auth?.id;

  if (!userId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">You must be logged in to use chat.</Typography>
      </Box>
    );
  }

  // ensure string | undefined (not null)
  const token: string | undefined =
    (localStorage.getItem("accessToken") ?? localStorage.getItem("token")) ?? undefined;

  return (
    <Box sx={{ p: 2 }}>
      {/* Use the typed alias so TS accepts the `authUser` prop */}
      <Provider authUser={{ id: userId, token }}>
        <Grid container spacing={2} sx={{ height: "calc(100vh - 140px)", pb: 2 }}>
          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Paper
              variant="outlined"
              sx={{ height: "100%", display: "flex", borderRadius: 2, overflow: "hidden" }}
            >
              <ChannelList />
            </Paper>
          </Grid>
          <Grid item xs={12} md={9} sx={{ height: "100%" }}>
            <ChatWindow currentUserId={userId} />
          </Grid>
        </Grid>
      </Provider>
    </Box>
  );
}
